import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScDialogData } from '../../../models';

// @dynamic
@Component({
  selector: 'sc-fullscreen-dialog',
  templateUrl: './sc-fullscreen-dialog.component.html',
  styleUrls: ['./sc-fullscreen-dialog.component.scss']
})
export class ScFullscreenDialogComponent implements OnInit, OnDestroy {
  public data: ScDialogData;

  constructor(private _dialogRef: MatDialogRef<ScFullscreenDialogComponent>, @Inject(MAT_DIALOG_DATA) public _data: ScDialogData) {
    this.data = this._data;
  }

  public ngOnInit() {}

  public onClose(): void {
    this._dialogRef.close(false);
  }

  public ngOnDestroy(): void {}
}
